import { useSelector } from 'react-redux';
import { useTranslate } from '@common/Translations';
import { GenderFilterItem as GenderFilterItemView } from '../components/GenderFilterItem';
import { GENDER_TYPES } from '../constants/genderTypes';

export function GenderFilterItem({
    filter,
    isActive,
    onClick
}) {
    const translate = useTranslate();
    const { gender } = useSelector(({ listing }) => listing);
    const { name } = filter;

    const handleClick = () => {
        onClick(filter);
    };

    const labelTranslationKey = gender === GENDER_TYPES.kids
        ? `listing.filter.kids.${name}` : `listing.gender.${name}.label`;

    return (
        <GenderFilterItemView
            icon={isActive ? 'checkbox_grey_selected' : 'checkbox_unselected'}
            label={translate(labelTranslationKey)}
            onClick={handleClick}
        />
    );
}
